export const FILTER_FILTERSTATUSES = 'filterStatuses';
export const FILTER_NETWORKS = 'networks';
export const FILTER_PLATFORMS = 'platforms';
export const FILTER_APPLICATIONS = 'applications';
export const FILTER_COUNTRIES = 'countryCodes';
export const FILTER_CREATED_BY = 'createdBy';
export const FILTER_OWNERS = 'owners';
export const FILTER_TYPES = 'types';

export const FILTERS_DEPENDENCIES = {
  [FILTER_APPLICATIONS]: [FILTER_NETWORKS],
  [FILTER_PLATFORMS]: [FILTER_NETWORKS],
};

export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_OWNER = 'owner';
export const COLUMN_TYPE = 'type';
export const COLUMN_PARTNER_AUDIENCES = 'partnerAudiences';
export const COLUMN_FILTERSTATUS = 'filterStatus';
export const COLUMN_SIZE = 'size';
export const COLUMN_ATT_EXCLUDED_SIZE = 'attExcludedSize';
export const COLUMN_SYNC_DATE = 'lastSyncDate';
export const COLUMN_NETWORKS = 'networks';
export const COLUMN_PLATFORMS = 'platforms';
export const COLUMN_APPLICATIONS = 'applications';
export const COLUMN_COUNTRIES = 'countryCodes';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED_DATE = 'createdDate';
export const COLUMN_UPDATED_DATE = 'updatedDate';

export const PERMISSION_EXPORT = 26;

export const PERMISSION_GRID_EXPORT = 52;
export const TRAFFIC_TYPE_ADVERTISING = 1;
export const MOBILE_NETWORK_ID = 30;

export const ACTION_ARCHIVE = 'archive';
export const ACTION_RESTORE = 'restore';
export const ACTION_DELETE = 'delete';
export const ACTION_DUPLICATE = 'duplicate';
export const ACTION_EDIT = 'edit';
export const ACTION_EXPORT = 'download';
export const ACTION_UPDATE = 'update';
export const ACTION_ADD_PARTNER_AUDIENCES = 'add_partner_audiences';
export const ACTION_SYNC_PARTNER_AUDIENCES = 'sync_partner_audiences';
export const PERMISSION_DOWNLOAD_NON_HASHED = 27;

export const TYPE_AUDIENCE = 0;
export const TYPE_FILE_BASED_AUDIENCE = 1;
